import CanalCobroCrud from './CanalCobroCrud'
export {CanalCobroCrud}
export default CanalCobroCrud
